module.exports = __webpack_public_path__ + "images/b65ab88c2656f07cbaef098026fca694.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/back.png
// module id = 358
// module chunks = 0